import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Reviews } from 'shared/presenters/graphqlTypes'
import { RecursivePartial } from 'shared/presenters/presenter'
import Rating from 'library/molecules/Rating'
import Flex from 'shared/library/atoms/Flex'
import { Text } from 'library/atoms/Typography'
import dayjs from 'dayjs'
import Image from 'next/image'
import { definedNotNull } from 'shared/presenters/presenter'

import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

/**
 * this method was cribbed from a stackoverflow post. It's the best way to truncate a string
 * on a word boundary so we dont get truncated words. Copilot is probably best to explain
 * what each unicode charachter is, includes things sucj as tabs, spaces, newlines, etc.
 **/
function truncateOnWord(str: string, limit: number) {
  const trimmable =
    '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF'
  const reg = new RegExp('(?=[' + trimmable + '])')
  const words = str.split(reg)
  let count = 0
  const return_words = words
    .filter(function (word) {
      count += word.length
      return count <= limit
    })
    .join('')

  return return_words + (str.length > return_words.length ? ' ...' : '')
}

const ReviewCard = ({
  review,
  starColor
}: {
  review: RecursivePartial<Reviews>
  starColor?: 'gold'
}) => {
  return (
    <StyledReview>
      <Flex alignItems="center" gap={1}>
        <Rating
          score={definedNotNull(review.rating)}
          maxScore={5}
          starColor={starColor}
        />
        <Text color="secondary" fontStyle="p3">
          {dayjs(review.reviewed_at).fromNow()}
        </Text>
      </Flex>

      <Text mb={3}>{truncateOnWord(definedNotNull(review.text), 220)}</Text>
      <Flex alignItems="center" gap={2}>
        {review.author_image && (
          <Image
            src={review.author_image}
            alt={review.author || 'Anonymous'}
            width={40}
            height={40}
          />
        )}
        <Reviewer color="secondary" mt={3}>
          {review.author}
        </Reviewer>
      </Flex>
    </StyledReview>
  )
}

export default ReviewCard

const StyledReview = styled(Flex)(({ theme }) =>
  css({
    flexDirection: 'column',
    padding: theme.mixins.pxSpread([theme.space[3], theme.space[4]]),
    border: `1px solid ${theme.colors.border.primary}`,
    borderRadius: theme.radii[3],
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: theme.colors.background.primary,
    boxShadow: theme.shadows.primary[0]
  })
)

const Reviewer = styled(Text)(() =>
  css({
    margin: 0
  })
)
